import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import styles from './Assettext.module.css'

export type AssettextProps = {
  title?: string
  subtitle?: string
  subtitle_asset?: any
  content?: React.ReactNode
  stickyContent?: boolean
  button?: React.ReactNode
  asset?: React.ReactNode
  assetLink?: {
    url: string
    target: string
  }
  assetCount?: number
  reverse?: boolean
  mobileReverse?: boolean
  layout?: 'default' | 'short' | 'center' | 'list' | 'inner-coloured' | 'inner-coloured-center'
  secondary_content_layout?: any
  feature?: boolean
  featureVariant?: 'primary' | 'secondary' | 'tertiary' | 'quinary'
  featureStyle?: 'default' | 'centered' | 'float'
  featureWaveStyle?: 'top' | 'bottom' | 'both'
  formAlign?: boolean
} & StylePanelProps

export const PhnxAssettext: React.FC<AssettextProps> = ({
  title,
  subtitle,
  subtitle_asset,
  content,
  button,
  asset,
  assetCount,
  reverse,
  mobileReverse,
  layout = 'default',
  secondary_content_layout = 'default',
  stickyContent = false,
  padding,
  backgroundColor,
  textColor,
  feature = false,
  featureVariant = 'primary',
  featureStyle = 'default',
  featureWaveStyle = 'both',
  formAlign = false,
  assetLink,
}) => {
  const paddingStyles = useResponsivePadding(padding)

  if (feature) {
    backgroundColor =
      featureVariant === 'primary'
        ? '#f15f3b'
        : featureVariant === 'secondary'
          ? '#90c764'
          : featureVariant === 'tertiary'
            ? '#7ac5e3'
            : '#FFFFFF'
    textColor = featureVariant === 'quinary' ? '#000000' : '#FFFFFF'
  }
  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }

  return (
    <div
      style={style}
      className={`stylepanel ${styles['assettext-relative']} ${feature ? styles[`feature-${featureVariant}`] : ''}`}
    >
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      {feature &&
        featureVariant !== 'quinary' &&
        (featureWaveStyle === 'top' || featureWaveStyle === 'both') && (
          <div className={styles['feature-before']}></div>
        )}
      <div
        className={`${styles['assettext']} ${reverse ? styles['reverse'] : ''} ${feature && featureVariant !== 'quinary' ? styles[`feature`] : ''} ${mobileReverse ? styles['mobile-reverse'] : ''} ${styles[`layout-${layout}`]} container grid-tw-container video-top`}
        data-testid="assettext"
        data-test-layout={layout}
        data-test-reverse={reverse}
        data-test-mobile-reverse={mobileReverse}
      >
        {layout === 'list' ? (
          <div className={`${styles['text-holder-col1']}`}>
            {content && (
              <div className={styles['content']}>
                {assetLink && assetLink.url !== undefined && assetLink.url !== '' ? (
                  <a href={assetLink.url} target={assetLink.target}>
                    {asset}
                  </a>
                ) : (
                  asset
                )}
              </div>
            )}
          </div>
        ) : asset ? (
          <div
            className={`${styles['asset-holder']} ${assetCount === 2 ? styles[`assetstyle-multi`] : ''} ${feature && featureVariant !== 'quinary' ? styles[`featureStyle-${featureStyle}`] : feature ? styles[`feature-quinary`] : ''} ${secondary_content_layout ? styles[`layout-${secondary_content_layout}`] : ''}`}
            data-testid="asset-holder"
            data-test-layout={secondary_content_layout}
          >
            {assetLink && assetLink.url !== undefined && assetLink.url !== '' ? (
              <a href={assetLink.url} target={assetLink.target}>
                {asset}
              </a>
            ) : (
              asset
            )}
          </div>
        ) : (
          <></>
        )}
        <div
          className={`${styles['text-holder']} ${feature && featureVariant !== 'quinary' ? styles[`featureStyle-${featureStyle}`] : feature ? styles[`feature-quinary`] : ''} `}
        >
          <div className={`${stickyContent ? styles['sticky'] : ''}`}>
            <div className="title-container-group">
              {title && (
                <div className="title" data-testid="title">
                  {title}
                </div>
              )}
              {subtitle && (
                <div
                  className={`${styles['subtitle']} ${subtitle_asset?.src ? styles['has-asset'] : ''} ${formAlign ? styles['form-align'] : ''} `}
                  data-testid="subtitle"
                  data-form-align={formAlign}
                >
                  {subtitle_asset && subtitle_asset.src && (
                    <div className={styles['subtitle-asset']}>
                      <img src={subtitle_asset.src} alt={subtitle_asset.alt} />
                    </div>
                  )}
                  {formAlign && (
                    <h2
                      className={`${formAlign ? styles['form-align'] : ''} subtitle`}
                      dangerouslySetInnerHTML={{
                        __html: subtitle,
                      }}
                    ></h2>
                  )}
                  {!formAlign && subtitle && (
                    <h2
                      className="subtitle"
                      dangerouslySetInnerHTML={{
                        __html: subtitle,
                      }}
                    ></h2>
                  )}
                </div>
              )}
            </div>
            {content && <div className={styles['content']}>{content}</div>}
            {layout !== 'list' && button && (
              <div className={styles['button-holder']} data-testid="button">
                {button}
              </div>
            )}
          </div>
        </div>
        {layout === 'list' && button && (
          <div className={styles['button-holder-list']} data-testid="button">
            {button}
          </div>
        )}
      </div>
      {feature &&
        featureVariant !== 'quinary' &&
        (featureWaveStyle === 'bottom' || featureWaveStyle === 'both') && (
          <div className={styles['feature-after']}></div>
        )}
    </div>
  )
}
